module.exports = __webpack_public_path__ + "assets/2a9c73f9808a916662a52eaf5314c19e.png";